// NOTE: when adding new values, make sure to check dining_option_schema to see if the new enum
// values should be added into any conditions
enum FulfillmentMethod {
  KIOSK_TO_GO = 1,
  KIOSK_DINE_IN = 2,
  FLASH_TO_GO = 3,
  FLASH_DINE_IN = 4,
  FLASH_CURBSIDE = 5,
  FLASH_OUTPOST = 6,
  KIOSK_OUTPOST = 7,
  FLASH_DELIVERY = 8,

  WEB_TO_GO = 20,
  WEB_DINE_IN = 21,
  WEB_CURBSIDE = 22,
  WEB_OUTPOST = 23,
  WEB_DELIVERY = 24,

  CATERING_TO_GO = 30,
  CATERING_DINE_IN = 31,
  CATERING_CURBSIDE = 32,
  CATERING_OUTPOST = 33,
  CATERING_DELIVERY = 34,

  LINEBUSTER_TO_GO = 40,
  LINEBUSTER_DINE_IN = 41,
  LINEBUSTER_CURBSIDE = 42,

  DRIVE_THRU_TO_GO = 50,
}

export { FulfillmentMethod };
